import {IController, IHttpResponse} from "angular";
import {OpportunitySetting} from "modules/user_settings/model/enums/enums";
import {UserSettingsService, UserSettingsServiceName} from "modules/user_settings/service/UserSettingsService";

import "../../../styles/right-side.scss"
import {PreviewResponse} from "modules/user_settings/model/PreviewResponse";
import {UserSettings} from "modules/user_settings/model/UserSettings";

export class RightSide implements IController {


    public selectedOpportunity: OpportunitySetting = OpportunitySetting.RATE_CALCULATOR;
    public opportunityList: Array<OpportunitySetting>;
    public emailPreviewData: string;
    public isLoading: boolean = false;
    public signature: string;
    public updatedSettings: UserSettings;

    public static instance = {
        template: require('./right-side.html'),
        controller: [
            UserSettingsServiceName,
            RightSide
        ],
        bindings: {
            updatedSettings: '<',
        },
    };

    constructor(
        private userSettingsService: UserSettingsService,
    ) {
    }

    $onInit() {

    }

    selectOpportunity(opportunity: OpportunitySetting) {
        this.selectedOpportunity = opportunity;
        console.log("Selected Opportunity:", this.selectedOpportunity);
    }

    renderPreview() { //need to replace
        const enumKeyFromValue = this.getEnumKeyFromValue(this.selectedOpportunity);
        this.isLoading = true;
        this.setSign();
        this.userSettingsService.renderPreviewCall(this.updatedSettings, enumKeyFromValue,
            this.renderPreviewCallback, () => this.isLoading = false)
    }

    renderPreviewCallback = (response: IHttpResponse<PreviewResponse>) => {
        this.emailPreviewData = response.data.response.replace(/\n/g, '<br>') + this.signature;
    };

    setSign = () => {
        this.userSettingsService.fetchSignature()
            .then((response: IHttpResponse<string>) => {
                this.signature = response.data;
            }).catch((error) => {
            console.error("Error rendering signature", error);
        })
    }

    handleOpportunitySelect = (opportunity: OpportunitySetting) => this.selectedOpportunity = opportunity;

    getEnumKeyFromValue = (value: string) => Object.keys(OpportunitySetting)
        .find(key => OpportunitySetting[key as keyof typeof OpportunitySetting] === value) || '';


}
